<!-- <app-chat-bar [userDataArray]="chatDataArray"></app-chat-bar> -->
<app-chat-bar></app-chat-bar>